<template>
  <ViewWrapper
    class="loading-overlay"
    :sound-controllable="false"
    :indicator-percentage="loadingProgressPercentage"
  >
    <div class="loading-overlay__content">
      <h2 ref="headline" class="loading-overlay__headline">{{ $t('status.loading.welcome') }}</h2>
      <p ref="paragraph">{{ $t('status.loading.loading') }}</p>
    </div>
  </ViewWrapper>
</template>

<script>
import { gsap } from 'gsap/all';
import ViewWrapper from '../ViewWrapper';

export default {
  name: 'LoadingOverlay',

  components: {
    ViewWrapper,
  },

  data() {
    return {
      counterTime: 0,
      counterIntervall: null,
    };
  },
  computed: {
    loadingProgressPercentage() {
      return this.counterTime / 2 - 1;
    },
  },

  mounted() {
    this.counterTime++;
    // TODO: Replace with real loading progress later on...
    this.counterIntervall = setInterval(() => {
      this.counterTime++;
    }, 1000);

    this.$once('hook:beforeDestroy', () => {
      clearInterval(this.counterIntervall);
    });

    gsap.fromTo(this.$refs.headline, 1, { opacity: 0.5, y: -3 }, { opacity: 1, y: 0 });

    gsap.to(this.$refs.paragraph, {
      duration: 1,
      scaleX: 1.1,
      scaleY: 1.1,
      repeat: -1,
      ease: 'Quad.easeInOut',
      yoyoEase: 'Quad.easeInOut',
    });
  },
};
</script>

<style lang="scss" scoped>
.loading-overlay {
  background-color: $color-background;
  background-image: url('./assets/world-bg.jpg');
  background-size: 736px;
  background-repeat: no-repeat;
  background-position: center;

  p {
    margin: 0;
  }
}

.loading-overlay__headline {
  @include font-headline;
  padding-bottom: 10px;
  font-weight: bold;
}

.loading-overlay__content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
</style>
